@let highlightTextResponse = this.highlightTextId();
@let buttonResponse = this.buttonId();

<div class="app-component-container outer-container">
    <div class="inner-container">
        @if(highlightTextResponse.success){
            <app-editable-text [elemId]="highlightTextResponse.payload"></app-editable-text>     
        }
        @if(buttonResponse.success){
            <app-editable-button [elemId]="buttonResponse.payload"></app-editable-button>
        }
    </div>
</div>
